import { render, staticRenderFns } from "./ViewGatGridEvents.vue?vue&type=template&id=952a9290&scoped=true&"
import script from "./ViewGatGridEvents.vue?vue&type=script&lang=js&"
export * from "./ViewGatGridEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952a9290",
  null
  
)

export default component.exports